import * as React from "react";
import Svg, { G, Rect, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={44}
    height={44}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_2679_774)">
      <Rect width={44} height={44} fill={props.bgColor || "#EBF2FF"} />
      <G clipPath="url(#clip1_2679_774)">
        <Path
          d="M23.8378 11.3599L17.7578 33.4399L29.2778 22.1199L23.8378 11.3599Z"
          fill={props.bgColor || "#EBF2FF"}
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M19 11L13 33.72L24.64 22.48L19 11Z"
          fill={props.bgColor || "#EBF2FF"}
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_2679_774">
        <Rect width={44} height={44} rx={6.28571} fill={props.bgColor || "#EBF2FF"} />
      </ClipPath>
      <ClipPath id="clip1_2679_774">
        <Rect width={26} height={26} fill={props.bgColor || "#EBF2FF"} transform="translate(9 9)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
